import { render } from "./BaseLocaleSelect.vue?vue&type=template&id=3c5df31c&scoped=true&ts=true"
import script from "./BaseLocaleSelect.vue?vue&type=script&lang=ts"
export * from "./BaseLocaleSelect.vue?vue&type=script&lang=ts"

import "./BaseLocaleSelect.vue?vue&type=style&index=0&id=3c5df31c&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5df31c"]])

export default __exports__